import { createSelector } from "reselect";

import { RootState } from "../../../store/rootReducer";

const state = ({ map }: RootState) => map;

export const mapSelector = createSelector(state, (map) => map);

export const a = 10;
